import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  formatDateTimeStamp,
  getFormattedDate,
  getRegionCurrency,
  isLargeScreen,
} from '../../../../../global.variable';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { DatetimePickerComponent } from '../../../../shared/components/datetime-picker/datetime-picker.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { ClientsService } from '../../clients/clients.service';
import { JobsService } from '../../jobs/jobs.service';
@Component({
  selector: 'gtapp-invoice-jobs',
  templateUrl: './invoice-jobs.component.html',
  styleUrl: './invoice-jobs.component.scss',
  standalone: false,
})
export class InvoiceJobsComponent implements OnInit, OnDestroy {
  // filter add more jobs params
  previousAddMoreJobs: number = 0;
  rowsAddMoreJobs: number = 15;
  pageNumAddMoreJobs: number = 1;
  totalPagesAddMoreJobs: number = 0;
  totalRowsAddMoreJobs: number = 0;
  sortKeyAddMoreJobs: any = '';
  totalAddMoreJobsCount: number = 0;
  dateRangeValueAddMoreJobs: string = '';
  dateRangeAddMoreJobs: any = { start: Date, end: Date };
  addMoreJobsSearchStr: string = '';
  addMoreJobDataList: any = [];
  selectedJobsToAddToInvoice: any = [];

  previousEvent: number = 0;
  rowsEvent: number = 15;
  pageNumEvent: number = 1;
  totalPagesEvent: number = 0;
  totalRowsEvent: number = 0;
  sortKeyEvent: any = '';
  totalEventCount: number = 0;
  // dict keys
  // IDENTITY_COMPLETE = 1, _("COMPLETE")
  // IDENTITY_APPROVE = 10, _("APPROVE")
  // IDENTITY_INVOICED = 11, _("INVOICED")
  // IDENTITY_DO_NOT_INVOICE = 12, _("DO NOT INVOICE")
  // IDENTITY_PAID = 13, _("PAID")

  tabEventDataList: any = [];
  tabDataCount: number = 0;
  selectedEvents: any = [];

  allEventsSelected: boolean = false;
  @ViewChild('donInvoiceTemplate', { static: true })
  donInvoiceTemplate: any;

  selectedEventIds: any = [];
  eventSearchStr: string = '';

  eventInvoiceStatusData: any = {};
  selectedEventStatus: any;
  dNotInvoiceReason: string = '';

  donInvoiceStatusId: string = '';

  positionStrategy: any;
  templateWidth: any = '0px';

  jobTypesDataList: any = [];
  selectedJobTypeId: string = '';

  uiTabs = {
    //  NOTE: Refactor this.getTabData() if the order of the tab is changed
    tab1: 'Ready for Invoicing',
    tab2: 'Invoiced',
    tab3: 'Paid Invoices',
    tab4: 'DO NOT INVOICE',
  };

  tabClass: any = {
    tab2: 'invoice-table-tab2 p-2 rounded-2 text-dark',
    tab3: 'invoice-table-tab3  p-2 rounded-2 text-dark',
    tab4: 'invoice-table-tab4  p-2 rounded-2 text-dark',
  };

  selectedTab: string = this.uiTabs.tab1;
  largeView = isLargeScreen;
  tableColumns: any = {
    col1: { key: 'report_date', sortOrder: 'desc' },
    col2: { key: 'job_type' },
    col3: { key: 'site' },
    col4: { key: 'event_id' },
    col5: { key: 'client' },
    col6: { key: 'status_changed_at' },
  };

  selectedStatusNumList: any = [];
  dateRangeValue: string = '';
  dateRange: any = { start: Date, end: Date };
  dateRangeBackup: any = { start: Date, end: Date };

  // search by client params
  clientDropDownList: any = [];
  clientDropDownListBackup: any = [];
  selectedClient: any;
  sameClientCheck: boolean = false;

  regionCurrencySymbol = getRegionCurrency(true);

  dialogRef: any;

  jobListView: boolean = true;
  taxConvertionFactor: number = 1.1;

  invoiceNum: string = '';
  backupInvoiceNum: string = '';

  invoiceDate: any;
  backupInvoiceDate: any;

  backUpInvoiceDataList: any = [];

  onsiteDurationDict: any = {};

  additionalLineItems: any = [];
  backUpAdditionalLineItems: any = [];

  existingLineItemList: any = [];

  filteredLineItems: any = [];

  // search by client params
  siteDropDownList: any = [];
  siteDropDownListBackup: any = [];
  selectedSite: any;

  selectedReportRecipientList: any = [];
  reportRecipientList: any = [];
  hasAppliedAnyFilter: boolean = false;

  prefilDataForJobs: any = {};
  prefilOptionFocused: string = '';

  newInvoiceCreated: boolean = false;
  constructor(
    private jobService: JobsService,
    private spinnerService: LoadingSpinnerService,
    private router: Router,
    private toasterService: ToasterService,
    private viewContainerRef: ViewContainerRef,
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
    let savedTab = sessionStorage.getItem('selectedTab');
    if (!savedTab) savedTab = this.selectedTab;
    this.changeTab(savedTab);

    // else {
    //   this.resetPagination();
    //   this.resetDateRange();
    // }

    this.getJobStatuses();

    this.searchClients('');
  }

  getInvoiceCount() {
    this.jobService
      .getManageInvoiceEvents({}, { get_invoice_count: 1 })
      .then((response: any) => {
        if (response?.status === 'success') {
          this.invoiceNum = response?.data;
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  resetDateRange() {
    const endDay = new Date();
    endDay.setMinutes(endDay.getMinutes() + 1);
    endDay.setMilliseconds(0);
    endDay.setSeconds(0);
    const startDay = new Date();
    startDay.setDate(new Date().getDate() - 3);
    startDay.setMilliseconds(0);
    startDay.setSeconds(0);

    this.dateRange = { start: startDay, end: endDay };

    this.dateRangeBackup = {
      start: new Date(this.dateRange?.start?.getTime()),
      end: new Date(this.dateRange?.end?.getTime()),
    };

    this.dateRangeValue = `${String(
      formatDateTimeStamp(this.dateRange?.start, 'd MMM y HH:mm', 'en_US'),
    )} - ${String(
      formatDateTimeStamp(this.dateRange?.end, 'd MMM y HH:mm', 'en_US'),
    )}`;
    this.dateRangeAddMoreJobs = {
      start: startDay,
      end: new Date(),
    };
    this.dateRangeValueAddMoreJobs = `${String(
      formatDateTimeStamp(
        this.dateRangeAddMoreJobs?.start,
        'd MMM y HH:mm',
        'en_US',
      ),
    )} - ${String(
      formatDateTimeStamp(
        this.dateRangeAddMoreJobs?.end,
        'd MMM y HH:mm',
        'en_US',
      ),
    )}`;
  }

  resetPagination() {
    this.previousEvent = 0;
    this.rowsEvent = 15;
    this.pageNumEvent = 1;
    this.totalPagesEvent = 0;
    this.totalRowsEvent = 0;
  }
  ngOnDestroy(): void {
    this.saveFilters();
    this.dialogRef?.close();
  }
  getJobStatuses() {
    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.jobTypesDataList = response?.data || [];
        response.statuses?.forEach((status: any) => {
          if ([10, 11, 12, 13].includes(status?.status_identity?.value))
            this.eventInvoiceStatusData[status?.status_identity?.value] =
              status;
          if (status?.status_identity?.value === 12) {
            this.donInvoiceStatusId = status?.id;
          }
        });
      }
    });
  }

  getInvoiceEvents(showSpinner = true) {
    if (showSpinner) this.spinnerService.show();
    let params: any = {};
    params[this.jobListView ? 'list_jobs' : 'list_invoices'] = 1;
    let body: any = { statuses: this.selectedStatusNumList };
    if (this.rowsEvent) {
      params['rows'] = this.rowsEvent;
    }
    if (this.previousEvent) {
      params['previous'] = this.previousEvent;
    }
    if (this.sortKeyEvent) {
      params['sort_key'] = this.sortKeyEvent;
    }
    if (this.dateRange) {
      body.date_range = this.dateRange;
    }
    if (this.selectedJobTypeId) {
      body.job_type_id = this.selectedJobTypeId;
    }
    if (this.eventSearchStr) {
      body.full_search_str = this.eventSearchStr;
    }
    if (this.selectedClient?.id) {
      body.company_id = this.selectedClient?.id;
    }
    this.saveFilters();
    this.jobService
      .getManageInvoiceEvents(body, params)
      .then((response: any) => {
        if (response?.status === 'success') {
          this.tabEventDataList = response?.data;
          this.totalRowsEvent = response?.total_size;
          this.totalPagesEvent = Math.ceil(
            this.totalRowsEvent / this.rowsEvent,
          );

          if (
            this.newInvoiceCreated &&
            this.invoiceNum &&
            this.selectedTab === this.uiTabs.tab2
          ) {
            this.newInvoiceCreated = false;
            const newlyCreatedInvoice = this.tabEventDataList?.find(
              (inv: any) => this.invoiceNum === inv?.invoice_num,
            );

            if (newlyCreatedInvoice?.id) this.printInvoice(newlyCreatedInvoice);
          }
          this.spinnerService.hide();
          this.totalEventCount = response?.total_event_count;
          this.markPreviouslySelected();
          if (
            response?.onsite_duration_dict &&
            Object.keys(response?.onsite_duration_dict)?.length
          ) {
            this.onsiteDurationDict = response?.onsite_duration_dict;
          }
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  saveFilters() {
    let tabFilters: any = {
      pagination: {
        previousEvent: this.previousEvent,
        pageNumEvent: this.pageNumEvent,
        rowsEvent: this.rowsEvent,
      },
      eventSearchStr: this.eventSearchStr,
      selectedClient: this.selectedClient,
      dateRange: this.dateRange,
      selectedJobTypeId: this.selectedJobTypeId,
    };

    localStorage.setItem(
      btoa(`invoiceTabFilterParams_${this.selectedTab}`),
      btoa(JSON.stringify(tabFilters)),
    );

    this.hasAppliedAnyFilter =
      new Date(this.dateRangeBackup?.start)?.getTime() !==
        new Date(this.dateRange?.start)?.getTime() ||
      new Date(this.dateRangeBackup?.end)?.getTime() !==
        new Date(this.dateRange?.end)?.getTime() ||
      this.selectedClient?.id ||
      this.eventSearchStr;
  }
  resetAndFetchLatestData() {
    this.resetPagination();
    this.resetDateRange();
    this.selectedClient = null;
    this.eventSearchStr = '';
    this.hasAppliedAnyFilter = false;
    this.getTabData();
  }
  loadFilters(selectedTab: string) {
    this.resetPagination();
    this.resetDateRange();
    this.selectedClient = null;
    this.eventSearchStr = '';
    this.hasAppliedAnyFilter = false;
    if (!this.newInvoiceCreated) {
      let invoiceTabFilterParams: any = localStorage.getItem(
        btoa(`invoiceTabFilterParams_${selectedTab}`),
      );

      if (invoiceTabFilterParams) {
        invoiceTabFilterParams = JSON.parse(atob(invoiceTabFilterParams));

        if (Object.keys(invoiceTabFilterParams?.dateRange)?.length) {
          this.dateRange = invoiceTabFilterParams?.dateRange;

          this.dateRangeValue = `${String(
            formatDateTimeStamp(
              this.dateRange?.start,
              'd MMM y HH:mm',
              'en_US',
            ),
          )} - ${String(
            formatDateTimeStamp(this.dateRange?.end, 'd MMM y HH:mm', 'en_US'),
          )}`;
        }

        if (invoiceTabFilterParams?.selectedClient)
          this.selectedClient = invoiceTabFilterParams?.selectedClient;
        if (invoiceTabFilterParams?.selectedJobTypeId)
          this.selectedJobTypeId =
            invoiceTabFilterParams?.selectedJobTypeId || '';

        if (invoiceTabFilterParams?.eventSearchStr)
          this.eventSearchStr = invoiceTabFilterParams?.eventSearchStr;

        if (invoiceTabFilterParams?.pagination) {
          this.previousEvent =
            invoiceTabFilterParams?.pagination?.previousEvent;
          this.pageNumEvent = invoiceTabFilterParams?.pagination?.pageNumEvent;
          this.rowsEvent = invoiceTabFilterParams?.pagination?.rowsEvent || 10;
        }
      }
    }

    // setTimeout(() => {}, 500);
    this.getTabData();
  }

  onChangePagination(event: any) {
    this.previousEvent = event.previous;
    this.pageNumEvent = event.pageNum;
    this.rowsEvent = event.pageSize;

    this.getInvoiceEvents();
  }
  changeTab(event: any) {
    this.additionalLineItems = [];
    this.backUpAdditionalLineItems = [];
    this.allEventsSelected = false;
    this.selectedEventIds = [];
    this.filteredLineItems = [];

    this.selectedTab = event;
    sessionStorage.setItem('selectedTab', this.selectedTab);
    this.loadFilters(this.selectedTab);
  }

  getTabData() {
    this.selectedStatusNumList = [];
    switch (this.selectedTab) {
      case this.uiTabs.tab1:
        this.jobListView = true;
        this.selectedStatusNumList = [10, 1, 11, 13, 9];
        this.getPrefillDataForInvoices();
        this.getInvoiceEvents();
        break;
      case this.uiTabs.tab2:
        this.jobListView = false;
        this.sortKeyEvent = '';
        this.selectedStatusNumList = [11];
        this.getInvoiceEvents();
        break;
      case this.uiTabs.tab3:
        this.jobListView = false;
        this.sortKeyEvent = '';
        this.selectedStatusNumList = [13];
        this.getInvoiceEvents();
        break;
      case this.uiTabs.tab4:
        this.jobListView = true;
        this.selectedStatusNumList = [12];
        this.getInvoiceEvents();
        break;
    }
  }
  autoShiftTab() {
    this.dNotInvoiceReason = '';
    let changeTabTo = this.selectedTab;
    switch (this.selectedEventStatus?.status_identity?.value) {
      case 10:
        changeTabTo = this.uiTabs.tab1;
        break;
      case 1:
        changeTabTo = this.uiTabs.tab1;
        break;
      case 11:
        changeTabTo = this.uiTabs.tab2;
        break;
      case 13:
        changeTabTo = this.uiTabs.tab3;
        break;
      case 12:
        changeTabTo = this.uiTabs.tab4;
        break;
    }
    setTimeout(() => {
      this.changeTab(changeTabTo);
    }, 500);
  }

  markSelectedEvents(eventData: any) {
    eventData.selected = !eventData?.selected;

    if (eventData?.selected) {
      this.selectedEventIds.push(eventData?.id);
    } else {
      const index = this.selectedEventIds?.indexOf(eventData?.id, 0);
      if (index > -1) {
        this.selectedEventIds?.splice(index, 1);
      }
    }

    this.selectedEventIds = [...new Set(this.selectedEventIds)];

    this.allEventsSelected =
      this.selectedEventIds?.length === this.tabEventDataList?.length;

    this.selectedEvents = this.tabEventDataList?.filter(
      (event: any) => event?.selected,
    );
    if (this.selectedEvents?.length)
      this.sameClientCheck = this.selectedEvents?.every(
        (event: any) =>
          event?.company?.id === this.selectedEvents[0]?.company?.id,
      );
  }
  selectJobsToInvoice(eventData: any) {
    eventData.selected = !eventData?.selected;
    this.selectedJobsToAddToInvoice = this.addMoreJobDataList?.filter(
      (job: any) => job?.selected,
    );
  }

  clearAndFocusTextBox(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  openJobDetailPage(eventData: any) {
    this.router.navigate([`/job-review/${eventData?.job_key}`], {
      queryParams: { jId: eventData?.id },
    });
  }
  printInvoice(invoiceData: any) {
    this.router.navigate([
      '/print-invoice',
      { invKey: btoa(String(invoiceData?.id)) },
    ]);
  }

  getInvoiceAndGetJobs(invoiceData: any, invoiceJobBillTemplate?: any) {
    this.spinnerService.show();
    this.jobService
      .getManageInvoiceEvents(
        { invoice_id: invoiceData?.id },
        { get_jobs_under_invoice: 1 },
        false,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          this.spinnerService.hide();
          if (response?.data?.length) {
            this.invoiceNum = invoiceData?.invoice_num;
            this.backupInvoiceNum = invoiceData?.invoice_num;
            this.invoiceDate = getFormattedDate(invoiceData?.invoiced_at);
            this.backupInvoiceDate = getFormattedDate(invoiceData?.invoiced_at);
            this.additionalLineItems = [];
            this.backUpAdditionalLineItems = [];

            // additional line items that may be present in the invoice
            if (response?.additional_line_items?.length) {
              this.additionalLineItems = JSON.parse(
                JSON.stringify(response?.additional_line_items),
              );

              this.backUpAdditionalLineItems = JSON.parse(
                JSON.stringify(response?.additional_line_items),
              );
            }

            this.selectedEvents = JSON.parse(JSON.stringify(response?.data));

            this.backUpInvoiceDataList = JSON.parse(
              JSON.stringify(response?.data),
            );
            this.getExistingLineItemNames(invoiceData?.id);
            if (
              response?.onsite_duration_dict &&
              Object.keys(response?.onsite_duration_dict)?.length
            ) {
              this.onsiteDurationDict = response?.onsite_duration_dict;
            }

            this.dialogRef = this.dialogService.open(
              invoiceJobBillTemplate,
              {
                data: {
                  company_name: invoiceData?.company?.company_name,
                  company_id: invoiceData?.company?.id,
                  eventData: invoiceData,
                },
              },
              this.viewContainerRef,
            );
          }
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }

  bulkUpdateEvents(body: any, params: any, addDeviceInfo = true) {
    this.spinnerService.show();
    this.jobService
      .getManageInvoiceEvents(body, params, addDeviceInfo)
      .then((response: any) => {
        if (response?.status === 'success') {
          this.dialogRef?.close();
          this.autoShiftTab();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }

  selectAllEvents(event: any) {
    this.tabEventDataList?.forEach((element: any) => {
      element.selected = event.target.checked;
    });
    this.selectedEvents = this.tabEventDataList?.filter(
      (event: any) => event?.selected,
    );
    this.selectedEventIds = [
      ...new Set(this.selectedEvents?.map((event: any) => event?.id)),
    ];
    this.allEventsSelected =
      this.selectedEventIds?.length === this.tabEventDataList?.length;

    if (this.selectedEvents?.length)
      this.sameClientCheck = this.selectedEvents?.every(
        (event: any) =>
          event?.company?.id === this.selectedEvents[0]?.company?.id,
      );
  }
  filterEvents() {
    if (this.eventSearchStr?.length > 2 || !this.eventSearchStr) {
      this.resetPagination();
      this.getInvoiceEvents(false);
    }
  }
  onJobTypeFilterSelect(event: any) {
    this.selectedJobTypeId = event?.target?.value;
    this.resetPagination();
    this.getInvoiceEvents(false);
  }
  markPreviouslySelected() {
    this.tabEventDataList?.forEach(
      (item: any) =>
        (item.selected = this.selectedEventIds?.includes(item?.id)),
    );
    this.selectedEventIds = [
      ...new Set(
        this.tabEventDataList
          ?.filter((event: any) => event?.selected)
          ?.map((event: any) => event?.id),
      ),
    ];
    this.allEventsSelected =
      this.selectedEventIds?.length === this.tabEventDataList?.length;
  }
  updateJobStatus(newStatus: any, eventIdList: any) {
    this.selectedEventStatus = newStatus;

    if (newStatus?.id === this.donInvoiceStatusId) {
      this.selectedEventIds = eventIdList;
      this.dialogService.open(
        this.donInvoiceTemplate,
        {},
        this.viewContainerRef,
      );
    } else {
      this.bulkUpdateEvents(
        {
          event_ids: eventIdList,
          status_id: newStatus?.id,
        },
        { update_status: 1 },
        true,
      );
    }
  }
  updateInvoiceStatus(newStatus: any, eventIdList: any) {
    this.selectedEventStatus = newStatus;
    this.bulkUpdateEvents(
      {
        event_ids: eventIdList,
        status_id: newStatus?.id,
      },
      { update_invoice: 1 },
      true,
    );
  }
  donotInvoiceEvents() {
    this.bulkUpdateEvents(
      {
        event_ids: this.selectedEventIds,
        status_id: this.donInvoiceStatusId,
        reason: this.dNotInvoiceReason,
      },
      { update_status: 1 },
      true,
    );
  }
  sortField(column: any) {
    column['sortOrder'] = column?.sortOrder === 'asc' ? 'desc' : 'asc';
    this.sortKeyEvent = '';

    switch (column?.key) {
      case 'modified_at':
        this.sortKeyEvent = 'modified_date';
        break;
      case 'status_changed_at':
        this.sortKeyEvent = 'status_changed_at';
        break;
      case 'client':
        this.sortKeyEvent = 'company__company_name';
        break;
      case 'report_date':
        this.sortKeyEvent = 'report_date';
        break;
      case 'site':
        this.sortKeyEvent = 'site_name';
        break;
      case 'job_type':
        this.sortKeyEvent = 'job_type_name';
        break;
      case 'event_id':
        this.sortKeyEvent = 'job_key';
        break;
    }
    if (this.sortKeyEvent) {
      this.sortKeyEvent =
        column?.sortOrder == 'desc'
          ? `-${this.sortKeyEvent}`
          : this.sortKeyEvent;
      this.getInvoiceEvents();
    }
  }

  openRangePicker(_type: string = 'default', companyId?: string) {
    const dialogRef = this.dialogService.open(DatetimePickerComponent, {
      data: {
        dateRange:
          _type == 'default' ? this.dateRange : this.dateRangeAddMoreJobs,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        if (_type == 'default') {
          this.dateRange = value;
          this.dateRangeValue = `${String(
            formatDateTimeStamp(value?.start, 'd MMM y HH:mm', 'en_US'),
          )} - ${String(
            formatDateTimeStamp(value?.end, 'd MMM y HH:mm', 'en_US'),
          )}`;
          this.getInvoiceEvents();
        } else {
          this.dateRangeAddMoreJobs = value;
          this.dateRangeValueAddMoreJobs = `${String(
            formatDateTimeStamp(value?.start, 'd MMM y HH:mm', 'en_US'),
          )} - ${String(
            formatDateTimeStamp(value?.end, 'd MMM y HH:mm', 'en_US'),
          )}`;
          this.filterAddJobsToInvoice(companyId);
        }
      }
    });
  }
  onClientSearch(event: any) {
    if (
      event.target.value.length === 3 ||
      (event.target.value.length > 3 && this.clientDropDownList?.length)
    ) {
      this.searchClients(event.target.value);
    }
  }
  searchClients(searchStr?: any) {
    this.clientService.searchClients(searchStr).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.clientDropDownList = res?.data;
        if (!searchStr) {
          this.clientDropDownListBackup = JSON.parse(
            JSON.stringify(this.clientDropDownList),
          );
        }
      }
    });
  }
  onClientSelect(data: any) {
    this.selectedClient = data;
    this.allEventsSelected = false;
    this.selectedEventIds = [];
    this.eventSearchStr = '';
    this.resetPagination();
    this.getTabData();
  }
  editField(field: string) {
    this.selectedClient = null;
    this.updateInitialDataList(field);
    this.allEventsSelected = false;
    this.selectedEventIds = [];
    this.eventSearchStr = '';
    this.resetPagination();
    this.getTabData();
    this.shiftFocus('clientLookupId');
  }
  shiftFocus(elementId: any) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.focus();
    }, 300);
  }
  inputFocused(field: string) {
    this.selectedClient = null;
    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    this.clientDropDownList = [];
    setTimeout(() => {
      this.clientDropDownList = JSON.parse(
        JSON.stringify(this.clientDropDownListBackup || []),
      );
      this.cdr.detectChanges();
    }, 200);
  }
  openInvoiceTemplate(template: any, selectedEventIds: any) {
    this.selectedEvents = [];
    this.tabEventDataList?.forEach((event: any) => {
      event.selected = selectedEventIds?.includes(event?.id);
      if (event?.selected) {
        this.selectedEvents.push(event);
      }
    });

    this.selectedEventIds = [
      ...new Set(this.selectedEvents?.map((event: any) => event?.id)),
    ];
    this.invoiceDate = getFormattedDate();
    this.prefillData();
    this.getInvoiceCount();
    this.getExistingLineItemNames();
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {
          company_name: this.selectedEvents[0]?.company?.company_name,
          company_id: this.selectedEvents[0]?.company?.id,
        },
      },
      this.viewContainerRef,
    );
  }
  getJobInvoicePricingFormattedList(data: any) {
    return data?.map((event: any) => {
      let dict: any = {
        id: event?.id,
        total_amount: Number(event?.total_amount) || 0,
        tax_amount: Number(event?.tax_amount) || 0,
        sale_amount: Number(event?.sale_amount) || 0,
        company_id: event?.company?.id,
      };
      // if (event?.newFeeFields?.length) {
      //   const customFeeFields = event?.newFeeFields.map((cField: any) => {
      //     let customFeeDict = { ...cField };
      //     if ('index' in customFeeDict) delete customFeeDict['index'];
      //     return customFeeDict;
      //   });
      //   if (customFeeFields?.length) {
      //     dict['custom_fee_fields'] = customFeeFields;
      //   }
      // }
      return dict;
    });
  }
  getAddLineItemsInvoicePricingFormattedList(data: any) {
    return data?.map((event: any) => {
      let dict: any = {
        total_amount: Number(event?.total_amount) || 0,
        tax_amount: Number(event?.tax_amount) || 0,
        sale_amount: Number(event?.sale_amount) || 0,
        itemName: event?.itemName,
      };

      return dict;
    });
  }
  createNewInvoice() {
    const invoiceStatus = this.eventInvoiceStatusData?.[11];
    const eventData = this.getJobInvoicePricingFormattedList(
      this.selectedEvents,
    );
    const additionalLineItems = this.getAddLineItemsInvoicePricingFormattedList(
      this.additionalLineItems,
    );
    this.selectedEventStatus = invoiceStatus;
    this.newInvoiceCreated = true;
    this.bulkUpdateEvents(
      {
        events: eventData,
        additional_line_items: additionalLineItems,
        status_id: invoiceStatus?.id,
        invoice_num: this.invoiceNum,
        invoice_date: new Date(this.invoiceDate).getTime(),
      },
      { invoice_jobs: 1 },
      true,
    );
  }
  getTotalInvoiceAmount(amountType: string) {
    const events = this.selectedEvents?.concat(this.additionalLineItems);
    const totalAmount = events?.reduce((sum: any, item: any) => {
      // Ensure item.amount is a valid number before adding
      let amount = 0;
      if (amountType == 'sale') {
        amount = Number(item?.sale_amount);
      } else if (amountType == 'tax') {
        amount = Number(item?.tax_amount);
      } else {
        const taxAmt = Number(item?.tax_amount) || 0;
        const saleAmt = Number(item?.sale_amount) || amount;
        amount = taxAmt + saleAmt;
      }

      return sum + (isNaN(amount) ? 0 : amount);
    }, 0);

    return totalAmount?.toFixed(2);
  }

  checkAndGenerateUniqueInvoiceNum(eventData: any) {
    this.jobService
      .getManageInvoiceEvents({}, { generate_unique_invoice_number: 1 })
      .then((response: any) => {
        if (response?.status === 'success') {
          eventData.invoice_num = response?.data;
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  modifyJobAmount(jobData: any, amountType: string) {
    // Total Amount = Sale amount * 1.1
    // Sale amount = total amount / 1.1
    // Tax = Total amount - Sale amount
    if (amountType == 'sale') {
      // modify total and tax amount
      let saleAmt = Number(jobData?.sale_amount) || 0;

      saleAmt = isNaN(saleAmt) ? 0 : saleAmt;
      jobData.sale_amount = saleAmt;
      jobData.total_amount = (saleAmt * this.taxConvertionFactor)?.toFixed(2);
      jobData.tax_amount = (jobData?.total_amount - saleAmt)?.toFixed(2);
    } else {
      // modify sale and tax amount
      let totlAmt = Number(jobData?.total_amount) || 0;
      totlAmt = isNaN(totlAmt) ? 0 : totlAmt;
      jobData.total_amount = totlAmt;
      jobData.sale_amount = (totlAmt / this.taxConvertionFactor)?.toFixed(2);
      jobData.tax_amount = (totlAmt - jobData?.sale_amount)?.toFixed(2);
    }
  }
  updateInvoiceId(invId: any) {
    this.jobService
      .getManageInvoiceEvents(
        { invoice_num: this.invoiceNum, invoice_id: invId },
        { update_invoice_num: 1 },
        true,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          this.invoiceNum = response?.data;
          this.backupInvoiceNum = response?.data;
          this.getTabData();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  updateInvoiceDate(invId: any) {
    this.jobService
      .getManageInvoiceEvents(
        {
          invoice_date: new Date(this.invoiceDate).getTime(),
          invoice_id: invId,
        },
        { update_invoice_date: 1 },
        true,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          this.invoiceDate = getFormattedDate(response?.data);
          this.backupInvoiceDate = getFormattedDate(response?.data);

          this.getTabData();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  updateLineItemIndividualPricing(
    lineItemData: any,
    eventData: any,
    index: number,
  ) {
    const invoice_additional_info = {
      invoice_total_amount: Number(this.getTotalInvoiceAmount('total')),
      invoice_tax_amount: Number(this.getTotalInvoiceAmount('tax')),
      invoice_sale_amount: Number(this.getTotalInvoiceAmount('sale')),
    };
    let individual_data: any = {
      line_item_total_amount: Number(lineItemData?.total_amount),
      line_item_tax_amount: Number(lineItemData?.tax_amount),
      line_item_sale_amount: Number(lineItemData?.sale_amount),
    };

    // const customFeeFields = jobData?.newFeeFields.map((cField: any) => {
    //   let customFeeDict = { ...cField };
    //   if ('index' in customFeeDict) delete customFeeDict['index'];
    //   return customFeeDict;
    // });

    // individual_data['custom_fee_fields'] = customFeeFields;
    this.jobService
      .getManageInvoiceEvents(
        {
          line_item_id: lineItemData?.id,
          line_item_name: lineItemData?.itemName,
          invoice_id: eventData?.eventData?.id,
          individual_data: individual_data,
          invoice_additional_info: invoice_additional_info,
        },
        { update_invoice_line_item_detail: 1 },
        true,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          // this.invoiceNum = response?.data;
          // this.backupInvoiceNum = response?.data;
          this.backUpAdditionalLineItems[index] = lineItemData;
          this.getTabData();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  updateInvoiceIndividualPricing(jobData: any, eventData: any, index: number) {
    const invoice_additional_info = {
      invoice_total_amount: Number(this.getTotalInvoiceAmount('total')),
      invoice_tax_amount: Number(this.getTotalInvoiceAmount('tax')),
      invoice_sale_amount: Number(this.getTotalInvoiceAmount('sale')),
    };
    let individual_data: any = {
      job_invoice_total_amount: Number(jobData?.total_amount),
      job_invoice_tax_amount: Number(jobData?.tax_amount),
      job_invoice_sale_amount: Number(jobData?.sale_amount),
    };

    // const customFeeFields = jobData?.newFeeFields.map((cField: any) => {
    //   let customFeeDict = { ...cField };
    //   if ('index' in customFeeDict) delete customFeeDict['index'];
    //   return customFeeDict;
    // });

    // individual_data['custom_fee_fields'] = customFeeFields;
    this.jobService
      .getManageInvoiceEvents(
        {
          invoice_job_detail_id: jobData?.invoice_job_id,
          invoice_id: eventData?.eventData?.id,
          individual_data: individual_data,
          invoice_additional_info: invoice_additional_info,
        },
        { update_invoice_job_detail: 1 },
        true,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          // this.invoiceNum = response?.data;
          // this.backupInvoiceNum = response?.data;
          this.backUpInvoiceDataList[index] = jobData;
          this.getTabData();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  voidLineItem(
    invoiceId: any,
    lineItemId?: any,

    index?: number,
  ) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: '',
        message: `Delete this line item from the invoice?`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        let body: any = { invoice_id: invoiceId };
        if (lineItemId) {
          body.invoice_line_item_ids = [lineItemId];
        } else {
          this.dialogRef?.close();
        }
        this.spinnerService.show();
        this.jobService
          .getManageInvoiceEvents(body, { remove_line_item: 1 }, true)
          .then((response: any) => {
            if (response?.status === 'success') {
              // this.invoiceNum = response?.data;
              // this.backupInvoiceNum = response?.data;

              this.additionalLineItems?.splice(index, 1);

              this.backUpAdditionalLineItems?.splice(index, 1);

              this.getTabData();
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response?.message,
              });
            }
          });
      }
    });
  }
  voidInvoice(
    invoiceId: any,
    invoiceJobId?: any,
    jobData?: any,
    index?: number,
  ) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: '',
        message: invoiceJobId ? `Remove job from invoice?` : `Void invoice?`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        let body: any = { invoice_id: invoiceId };
        if (invoiceJobId) {
          body.invoice_job_detail_ids = [invoiceJobId];
        } else {
          this.dialogRef?.close();
        }
        this.spinnerService.show();
        this.jobService
          .getManageInvoiceEvents(body, { void_invoice: 1 }, true)
          .then((response: any) => {
            if (response?.status === 'success') {
              // this.invoiceNum = response?.data;
              // this.backupInvoiceNum = response?.data;
              if (invoiceJobId && jobData?.length) {
                jobData?.splice(index, 1);

                this.backUpInvoiceDataList?.splice(index, 1);
              }

              this.getTabData();
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response?.message,
              });
            }
          });
      }
    });
  }
  addMoreJobsToInvoice(template: any, companyId: string) {
    this.filterAddJobsToInvoice(companyId);
    const dialogRef = this.dialogService.open(
      template,
      {
        data: { companyId: companyId },
      },
      this.viewContainerRef,
    );
    dialogRef?.afterClosed()?.subscribe((res: any) => {
      if (res) {
        this.selectedEvents = this.selectedEvents?.concat(
          this.selectedJobsToAddToInvoice,
        );
        this.selectedJobsToAddToInvoice = [];
        this.addMoreJobsSearchStr = '';
        this.resetDateRange();
      }
    });
  }

  filterAddJobsToInvoice(companyId: any) {
    if (!companyId) return;
    let params: any = { list_jobs: 1 };

    let body: any = {
      statuses: [10, 1, 11, 13, 9],
      company_id: companyId,
    };
    if (this.rowsAddMoreJobs) {
      params['rows'] = this.rowsAddMoreJobs;
    }
    if (this.previousAddMoreJobs) {
      params['previous'] = this.previousAddMoreJobs;
    }
    if (this.sortKeyAddMoreJobs) {
      params['sort_key'] = this.sortKeyAddMoreJobs;
    }
    if (this.dateRangeAddMoreJobs) {
      body.date_range = this.dateRangeAddMoreJobs;
    }
    if (this.addMoreJobsSearchStr) {
      body.full_search_str = this.addMoreJobsSearchStr;
    }
    if (this.selectedEvents) {
      const eventIds = [
        ...new Set(this.selectedEvents?.map((job: any) => job?.id)),
      ];
      body.exclude_ids = eventIds;
    }

    this.jobService
      .getManageInvoiceEvents(body, params)
      .then((response: any) => {
        if (response?.status === 'success') {
          this.spinnerService.hide();
          this.addMoreJobDataList = response?.data;
          this.selectedJobsToAddToInvoice = [];
          this.totalRowsAddMoreJobs = response?.total_size;
          this.totalPagesAddMoreJobs = Math.ceil(
            this.totalRowsAddMoreJobs / this.rowsAddMoreJobs,
          );
          this.totalAddMoreJobsCount = response?.total_event_count;
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  onChangePaginationAddMoreJobs(event: any, companyId: string) {
    this.previousAddMoreJobs = event.previous;
    this.pageNumAddMoreJobs = event.pageNum;
    this.rowsAddMoreJobs = event.pageSize;
    this.filterAddJobsToInvoice(companyId);
  }
  invoiceNewJobsAndMarkPaid(invoiceId: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Add to  invoice',
        message: `This will add the new jobs/items to the invoice and mark the invoice as paid. Are you sure?`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        const result = this.selectedEvents?.filter(
          (item1: any) =>
            !this.backUpInvoiceDataList?.some(
              (item2: any) => item2?.id === item1?.id,
            ),
        );
        const extraLineItems = this.additionalLineItems?.filter(
          (item1: any) =>
            !this.backUpAdditionalLineItems?.some(
              (item2: any) => item2?.id === item1?.id,
            ),
        );

        if (result?.length || extraLineItems?.length) {
          this.spinnerService.show('Adding new jobs to the invoice');

          const invoiceStatus = this.eventInvoiceStatusData?.[11];
          const eventData = this.getJobInvoicePricingFormattedList(result);
          const additionalLineItems =
            this.getAddLineItemsInvoicePricingFormattedList(extraLineItems);

          this.selectedEventStatus = invoiceStatus;

          this.jobService
            .getManageInvoiceEvents(
              {
                events: eventData,
                status_id: invoiceStatus?.id,
                invoice_id: invoiceId,
                additional_line_items: additionalLineItems,
              },
              { add_new_jobs_to_invoice: 1 },
              true,
            )
            .then((response: any) => {
              if (response?.status === 'success') {
                this.spinnerService.show('Marking as paid');
                this.updateInvoiceStatus(this.eventInvoiceStatusData?.[13], [
                  invoiceId,
                ]);
              } else {
                this.spinnerService.hide();
                this.toasterService.setMessage({
                  successMessage: '',
                  errorMessage: response?.message,
                });
              }
            });
        }
      }
    });
  }
  addExistingLineItem(item: any) {
    const newItem = [{ itemName: item }];
    this.additionalLineItems = [...this.additionalLineItems, ...newItem];
    this.refreshCustomLineItemList();
  }
  refreshCustomLineItemList() {
    const existingLineItems: any = [
      ...new Set(
        this.additionalLineItems?.map((item: any) =>
          item?.itemName?.toLowerCase(),
        ),
      ),
    ];

    this.filteredLineItems = this.existingLineItemList?.filter(
      (item: any) => !existingLineItems?.includes(item?.toLowerCase()),
    );
  }
  openAddItemTemplate(template: any, data?: any) {
    const dialogRef = this.dialogService.open(
      template,
      {
        data: [{}],
      },
      this.viewContainerRef,
    );
    dialogRef?.afterClosed()?.subscribe((res: any) => {
      if (res?.template && res?._type) {
        if (res?._type == 'job') {
          this.addMoreJobsToInvoice(res?.template, data?.company_id);
        } else {
          this.openAdditionalItemAddTemplate(res?.template);
        }
      }
    });
  }
  openAdditionalItemAddTemplate(template: any) {
    const dialogRef = this.dialogService.open(
      template,
      {
        data: [{}],
      },
      this.viewContainerRef,
    );
    dialogRef?.afterClosed()?.subscribe((res: any) => {
      if (res) {
        this.additionalLineItems = [...this.additionalLineItems, ...res];
        this.refreshCustomLineItemList();
      }
    });
  }
  hasPricingChanged(backupValue: any, modifiedValue: any) {
    if (
      modifiedValue?.sale_amount !== backupValue?.sale_amount ||
      JSON.stringify(modifiedValue?.newFeeFields || []) !==
        JSON.stringify(backupValue?.newFeeFields || [])
    )
      return true;

    return false;
  }
  getExistingLineItemNames(invId?: any) {
    let body: any = {};
    if (invId) body.invoice_id = invId;
    this.jobService
      .getManageInvoiceEvents(body, { get_all_line_item_names: 1 }, true)
      .then((response: any) => {
        if (response?.status === 'success') {
          this.existingLineItemList = response?.data;
          this.refreshCustomLineItemList();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  onSiteSearch(event: any) {
    if (
      event.target.value.length === 3 ||
      (event.target.value.length > 3 && this.siteDropDownList?.length)
    ) {
      this.searchSites(event.target.value);
    }
  }
  searchSites(searchStr?: any) {
    this.clientService
      .searchSites({
        search_str: searchStr,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteDropDownList = res?.data?.splice(0, 10);

          if (!searchStr) {
            this.siteDropDownListBackup = JSON.parse(
              JSON.stringify(this.siteDropDownList),
            );
          }
        }
      });
  }
  onSiteSelect(data: any) {
    this.selectedSite = data;
    this.allEventsSelected = false;
    this.selectedEventIds = [];
    this.eventSearchStr = '';
    this.resetPagination();
    this.getTabData();
  }
  sendMultipleDockets(
    eventType = 'job',
    recipientListTemplate: any,
    eventIds: any,
  ) {
    let body: any = {};

    body[eventType == 'job' ? 'job_ids' : 'invoice_ids'] = eventIds;
    this.spinnerService.show();
    this.jobService
      .sendJobMultipleReports(body, { get_recipients: 1 })
      .then((response: any) => {
        if (response?.status === 'success') {
          this.reportRecipientList = response?.data;
          this.selectedReportRecipientList = [
            ...new Set(
              this.reportRecipientList
                ?.filter((recipient: any) => !recipient?.isSnubbed)
                ?.map((recipient: any) => recipient?.id),
            ),
          ];
          const dialogRef = this.dialogService.open(
            recipientListTemplate,
            {},
            this.viewContainerRef,
          );
          dialogRef.afterClosed().subscribe((value: any) => {
            if (value === true && this.selectedReportRecipientList?.length) {
              this.spinnerService.show();
              body.recipient_ids = this.selectedReportRecipientList;
              this.jobService
                .sendJobMultipleReports(body, {})
                .then((response: any) => {
                  if (response?.status === 'success') {
                    this.toasterService.setMessage({
                      successMessage: response?.message,
                      errorMessage: '',
                    });
                    this.spinnerService.hide();
                  } else {
                    this.toasterService.setMessage({
                      successMessage: '',
                      errorMessage: response?.message,
                    });
                    this.spinnerService.hide();
                  }
                });
            }
          });
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
        this.spinnerService.hide();
      });
  }
  selectUnselectRecipients(contact: any) {
    contact.isSnubbed = !contact?.isSnubbed;

    this.selectedReportRecipientList = [
      ...new Set(
        this.reportRecipientList
          ?.filter((recipient: any) => !recipient?.isSnubbed)
          ?.map((recipient: any) => recipient?.id),
      ),
    ];
  }
  updateInvoiceItems(invoiceData: any, getDetail = false) {
    if (!invoiceData?.id) return;
    if (
      this.backUpInvoiceDataList?.length === this.selectedEvents?.length &&
      this.backUpAdditionalLineItems?.length ===
        this.additionalLineItems?.length
    ) {
      return;
    }
    const result = this.selectedEvents?.filter(
      (item1: any) =>
        !this.backUpInvoiceDataList?.some(
          (item2: any) => item2?.id === item1?.id,
        ),
    );
    const extraLineItems = this.additionalLineItems?.filter(
      (item1: any) =>
        !this.backUpAdditionalLineItems?.some(
          (item2: any) => item2?.id === item1?.id,
        ),
    );

    if (result?.length || extraLineItems?.length) {
      this.spinnerService.show('Adding items to the invoice');

      const invoiceStatus = this.eventInvoiceStatusData?.[11];
      const eventData = this.getJobInvoicePricingFormattedList(result);
      const additionalLineItems =
        this.getAddLineItemsInvoicePricingFormattedList(extraLineItems);

      this.jobService
        .getManageInvoiceEvents(
          {
            events: eventData,
            status_id: invoiceStatus?.id,
            invoice_id: invoiceData?.id,
            additional_line_items: additionalLineItems,
          },
          { add_new_jobs_to_invoice: 1 },
          true,
        )
        .then((response: any) => {
          if (response?.status === 'success') {
            if (getDetail) {
              this.getInvoiceAndGetJobs(invoiceData);
            }
            this.getTabData();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response?.message,
            });
          }
        });
    }
  }
  getPrefillDataForInvoices() {
    this.jobService
      .getManageInvoiceEvents({}, { invoices_prefill_data: 1 }, false)
      .then((response: any) => {
        if (response?.status === 'success') {
          this.prefilDataForJobs = response?.data;
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  prefillData() {
    this.selectedEvents?.forEach((item: any, index: number) => {
      if (!item?.sale_amount) {
        item.sale_amount =
          this.prefilDataForJobs?.[item?.job_type_id]
            ?.job_invoice_sale_amount || 0;
        item.total_amount =
          this.prefilDataForJobs?.[item?.job_type_id]
            ?.job_invoice_total_amount || 0;
        item.tax_amount =
          this.prefilDataForJobs?.[item?.job_type_id]?.job_invoice_tax_amount ||
          0;
        item.backupData = JSON.parse(
          JSON.stringify({
            sale_amount: item.sale_amount,
            total_amount: item.total_amount,
            tax_amount: item.tax_amount,
          }),
        );
      }
    });
  }
  conditionalPrefillData(jobData: any) {
    this.selectedEvents?.forEach((item: any, index: number) => {
      if (item?.job_type_id === jobData?.job_type_id) {
        item.sale_amount = jobData?.sale_amount || 0;
        item.total_amount = jobData?.total_amount || 0;
        item.tax_amount = jobData?.tax_amount || 0;

        item.backupData = JSON.parse(
          JSON.stringify({
            sale_amount: item.sale_amount,
            total_amount: item.total_amount,
            tax_amount: item.tax_amount,
          }),
        );
      }
    });
  }
  markAsReceived(newStatus: any, eventIdList: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Payment Received',
        message: `Mark the ${
          eventIdList?.length == 1 ? 'invoice' : 'invoices'
        } as paid?`,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.updateInvoiceStatus(newStatus, eventIdList);
      }
    });
  }
}
